(() => {
  'use strict';
  const mounted = new Map();
  function mount(strip) {
    if (!strip || mounted.has(strip)) return;
    for (const [old, cleanup] of mounted) {
      if (!old.isConnected) { cleanup(); mounted.delete(old); }
    }
    const nav = strip.closest('.studio-design-category-nav');
    if (!nav) return;
    const previous = nav.querySelector('[data-design-category-prev]');
    const next = nav.querySelector('[data-design-category-next]');
    const events = new AbortController();
    const on = (target, name, callback, options = {}) => target.addEventListener(name, callback, { ...options, signal: events.signal });
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const move = delta => strip.scrollBy({ left: delta, behavior: reduced() ? 'instant' : 'smooth' });
    const update = () => {
      const max = strip.scrollWidth - strip.clientWidth;
      const overflow = max > 2;
      nav.classList.toggle('has-overflow', overflow);
      previous.disabled = !overflow || strip.scrollLeft <= 1;
      next.disabled = !overflow || strip.scrollLeft >= max - 1;
    };
    const reveal = button => {
      const left = button.offsetLeft - strip.offsetLeft;
      if (left < strip.scrollLeft) move(left - strip.scrollLeft - 4);
      else if (left + button.offsetWidth > strip.scrollLeft + strip.clientWidth) move(left + button.offsetWidth - strip.scrollLeft - strip.clientWidth + 4);
    };
    on(previous, 'click', () => move(-Math.max(120, strip.clientWidth * .75)));
    on(next, 'click', () => move(Math.max(120, strip.clientWidth * .75)));
    on(strip, 'scroll', update, { passive: true });
    on(strip, 'focusin', event => { if (event.target.matches('button')) reveal(event.target); });
    on(strip, 'keydown', event => {
      const buttons = [...strip.querySelectorAll('button')];
      const index = buttons.indexOf(event.target);
      if (index < 0) return;
      const target = event.key === 'ArrowRight' ? Math.min(index + 1, buttons.length - 1)
        : event.key === 'ArrowLeft' ? Math.max(index - 1, 0)
        : event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : -1;
      if (target < 0) return;
      event.preventDefault(); buttons[target].focus({ preventScroll: true }); reveal(buttons[target]);
    });
    on(strip, 'wheel', event => {
      if (event.ctrlKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
      const max = strip.scrollWidth - strip.clientWidth;
      const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? strip.clientWidth : 1);
      if (max <= 2 || delta < 0 && strip.scrollLeft <= 1 || delta > 0 && strip.scrollLeft >= max - 1) return;
      event.preventDefault(); strip.scrollLeft += delta;
    }, { passive: false });
    let drag = null, dragged = false;
    on(strip, 'pointerdown', event => {
      dragged = false;
      if (event.pointerType === 'touch' || event.button !== 0) return;
      drag = { id: event.pointerId, x: event.clientX, left: strip.scrollLeft };
    });
    on(strip, 'pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const delta = event.clientX - drag.x;
      if (!dragged && Math.abs(delta) < 6) return;
      dragged = true;
      if (!strip.hasPointerCapture(event.pointerId)) strip.setPointerCapture(event.pointerId);
      strip.classList.add('is-dragging');
      event.preventDefault(); strip.scrollLeft = drag.left - delta;
    });
    const end = event => {
      if (drag && strip.hasPointerCapture(drag.id)) strip.releasePointerCapture(drag.id);
      drag = null; strip.classList.remove('is-dragging');
      if (event.type === 'pointercancel') dragged = false;
    };
    on(strip, 'pointerup', end); on(strip, 'pointercancel', end); on(strip, 'lostpointercapture', end);
    on(strip, 'click', event => {
      if (dragged) { event.preventDefault(); event.stopImmediatePropagation(); dragged = false; }
    }, { capture: true });
    const observer = new ResizeObserver(update);
    observer.observe(strip);
    mounted.set(strip, () => { events.abort(); observer.disconnect(); });
    update();
  }
  window.OazarDesignCategories = { mount };
})();
